import { render, staticRenderFns } from "./qualificationService.vue?vue&type=template&id=5a3e5519&scoped=true&"
import script from "./qualificationService.vue?vue&type=script&lang=js&"
export * from "./qualificationService.vue?vue&type=script&lang=js&"
import style0 from "./qualificationService.vue?vue&type=style&index=0&id=5a3e5519&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e5519",
  null
  
)

export default component.exports